<script setup>
import FeaturedImage from "../Helpers/FeaturedImage";
import EnergyApi from "../Helpers/Api";
import Language from "../Helpers/Language";
import Arr from "../Helpers/Arr";
import {useI18n} from "vue-i18n";

const {t} = useI18n();

const props = defineProps({
    schedules: Array,
});

const formatScheduleDate = (schedule) => {
    const dateOptions = {hour: "numeric", minute: "numeric"};
    const startHour = new Date(schedule['start']).toLocaleTimeString(Language.getLanguage() ?? null, dateOptions);
    const endHour = new Date(schedule['end']).toLocaleTimeString(Language.getLanguage() ?? null, dateOptions);

    return Language.isPortuguese() ? `${startHour}h às ${endHour}h` : `${startHour} to ${endHour}`
}

</script>

<template>
    <section>
        <div v-for="(group, date) in schedules">
            <span><span></span>{{ date }}</span>
            <ul>
                <li v-for="schedule in Arr.sortByTimeKey(group, 'start')">
                    <div>
                        <div>
                            <h1>{{ schedule['title'] }}</h1>
                            <div>
                                <span v-if="schedule['stage']">
                                    <img :src="new EnergyApi().mountImageRootPath('localization.svg')"
                                         alt="Localization icon">
                                    {{ schedule['stage'] }}
                                </span>
                                <span>
                                    <img :src="new EnergyApi().mountImageRootPath('clock.svg')" alt="Clock icon">
                                    {{ formatScheduleDate(schedule) }}
                                </span>
                            </div>
                            <ul>
                                <li v-for="tag in schedule.tags">
                                    <span>{{ tag }}</span>
                                </li>
                            </ul>
                        </div>
                        <ul>
                            <li v-for="speaker in schedule['speakers']">
                                <figure>
                                    <picture>
                                        <img :src="FeaturedImage.getSpeakerFeaturedImageUrl(speaker)" alt="">
                                    </picture>
                                </figure>
                                <div>
                                    <a :href="speaker['share_url']"><h3>{{ speaker['name'] }}</h3></a>
                                    <h4>{{ speaker['bio'] }}<br><b>{{ speaker['company'] }}</b></h4>
                                </div>
                            </li>
                        </ul>
                    </div>
                </li>
            </ul>
        </div>
        <span>*{{ t('Programação sujeita a alteração') }}</span>
    </section>
</template>

<style scoped>

</style>
